import md5 from 'md5'
import { getCookieLanguageCode, getCookieCountryCode, iPhone } from '~/utils/utils'
import menu from '~/static/json/menu.json'
import index from '~/static/json/index.json' // 引入首页配置
import { noncooperativetrader } from '~/utils/cacheparams/index.js'
export default async ({ isHMR, app, $api, route, store, req, redirect, res }) => {
  if (isHMR) return false // 热更新状态下，不执行后续操作
  if (!req) return
  store.commit('setheadshow', !app.$cookies.get('head_tips')) // 获取顶部提示

  // 设置域名后缀
  let myDomin = req && req.headers.host.split('.')
  const host = req.headers.host.includes('aws') ? req.headers.host.replace('aws.', '') : req.headers.host // 获取域名不带www前缀
  if (route.path.includes('/HealthCheck/Get')) {
    // 屏蔽健康检查
    res.statusCode = 200
    return
  }
  console.log(req?.headers?.host, 9998)
  if (host.includes('googleusercontent') || route.fullPath.includes('q=cache')) console.log(route.fullPath, 333, host)
  const hostS = `https://${host}${route.fullPath}` // 获取主域名带当前页面地址
  store.commit('setnowtime') // 获取语言
  store.commit('setHostend', host)
  store.commit('setAllhost', hostS)
  myDomin = myDomin[myDomin.length - 1]
  if (host.includes(':')) {
    // 取主域名
    myDomin = myDomin.split(':')[0]
  }
  const routeLang = route.params.lang && route.params.lang.toLowerCase()
  if (myDomin == 'cc') {
    // 后缀为cc自动跳转到越南语
    store.commit('setLangCode', { lang: 'vi', hostS: host }) // 获取语言
    if (routeLang != 'vi') {
      return redirect(302, `/vi/${route.fullPath.split('/').slice(2).join('/')}`)
    }
  }
  try {
    const ENVIRONMENT = process?.env?.ENVIRONMENT || ''
    store.commit('setNodeEnv', ENVIRONMENT) // 获取环境变量
  } catch (err112) {
    console.log(err112, 113)
  }
  const addressip = req.headers['X-Forwarded-For']
    ? req.headers['X-Forwarded-For'].split(',')[0]
    : req.headers['x-forwarded-for']
      ? req.headers['x-forwarded-for'].split(',')[0]
      : req.connection.remoteAddress
  const realip = process.env.NODE_ENV === 'development' ? '' : addressip // 222.67.205.20
  const ua = req.headers && req.headers['user-agent'] ? req.headers['user-agent'] : ''
  const serverbfp = realip + '' + ua
  store.commit('serverbfpfn', md5(serverbfp))
  // console.log(md5(serverbfp), 2222)
  const userIp = await $api.home.getipgeo({ ip: realip, uparm2: 'web20' }).catch(() => {
    // 用户ip语言
    console.log('getipgeo')
  })
  store.commit('getIp', realip) // 获取用户ip
  const myCountry = userIp && userIp.country_code ? userIp.country_code : 'cn'
  if (myCountry.toLowerCase() == 'cn') {
    const cnplace = await $api.home.getip138({ ip: !realip ? '114.114.114.114' : realip }).catch(() => {
      // 用户ip语言
      console.log('getipgeo----error')
    })
    const myProvince = cnplace && cnplace.province ? cnplace.province : ''
    store.commit('getmyProvince', myProvince)
    const myCity = cnplace && cnplace.city ? cnplace.city : cnplace && cnplace.province
    // console.log(myCity, 887, myProvince)
    store.commit('getmyCity', myCity)
  }
  let cookieHost = host
    ? host.includes('192.168') || host.includes('10.10')
      ? host.split(':')[0]
      : host.includes('443')
        ? host.split(':')[0].substr(host.indexOf('.'))
        : host.substr(host.indexOf('.'))
    : '.wikifx.com'
  // console.log(route.fullPath.split('/').splice(2)?.join('/')?.split('?')?.[0], 9999)
  // store.commit('setPath', route.fullPath.split('/').splice(2)?.join('/')?.split('?')?.[0]) // 获取语言
  store.commit('setPath', route.fullPath.split('/').splice(2).join('/')) // 获取语言
  cookieHost = cookieHost.includes('aws') ? cookieHost.replace('aws.', '') : cookieHost
  if (!app.$cookies.get('isgoogle')) app.$cookies.set('isgoogle', 1, { path: '/', domain: cookieHost })
  store.commit('setcookieHost', cookieHost) // 处理好存cookie需要的路径域名
  // const newUrl = ['fxeye688', 'fxeye', 'fxeye2017', 'fxeye777', 'fxeye110', 'fxeye123']
  const urlBool = cookieHost ? cookieHost.split('.')[1] : cookieHost
  const suffix = process.env.NODE_ENV === 'development' ? 'com' : cookieHost?.split('.')?.[2] || 'com'
  store.commit('getuserAgent', ua)
  store.commit('setsuffix', suffix)
  let country = await getCookieCountryCode(req, app) // 获取设置国家cookie
  if (route?.fullPath?.includes('source=app')) {
    // app内嵌的情况下设置国家
    country = route?.query?.country || country
  }
  if (route?.fullPath?.includes('lcs=1')) {
    country = route?.query?.country || country
  }
  // 登录统计（商业个人列表页和详情页）
  // if (route?.query?.marketingActivity && route?.query?.marketingParam) app.$cookies.set('querymarket', 1, { path: '/', domain: cookieHost })
  // fxeye机器人检测
  const soureapp = route?.query?.source != 'app'
  if (
    (store.state.isWiki == '2' || store.state.isWiki == '3') &&
    store.state.isWiki != '4' &&
    myCountry.toLowerCase() == 'cn' &&
    soureapp &&
    !(cookieHost.includes('fxeyetips') && store.state.curProvince.includes('上海')) &&
    !(cookieHost.includes('fxeyevip') && store.state.curProvince.includes('上海'))
  ) {
    const PassCheckAuto = app.$cookies.get('PassCheckAuto')
    if (PassCheckAuto != '1' && !route.path.toLowerCase().includes('checkrobot.html')) {
      store.commit('setMyCountry', { myCountry, hostS: host }) // 存储用户所在的国家
      store.commit('setLangCode', { lang: 'zh-cn', hostS: host }) // 获取 语言
      store.commit('setCountryCode', { country: 'cn', hostS: host }) // 获取国家
      country = 'cn'
      let backurl = `/zh-cn/${route.fullPath.split('/').slice(2).join('/')}`
      backurl = decodeURIComponent(backurl).replace('/zh-cn/zh-cn', '/zh-cn')
      try {
        if (!(store.state.isWiki == '3' && ua && ua.toLowerCase().includes('baiduspider'))) {
          return redirect(302, `/zh-cn/checkrobot.html?backurl=${backurl}`)
        }
      } catch (err) {
        return redirect(302, `/zh-cn/checkrobot.html?backurl=${backurl}`)
      }
    }
  }
  if (store.state.isWiki == '2' || store.state.isWiki == '3' || store.state.isWiki == '4') {
    // 判断处理特殊域名
    store.commit('setHost', {
      host: urlBool,
      bool: true
    })
    if ((store.state.isWiki == '2' || store.state.isWiki == '4') && (!hostS.includes('/zh-cn') || app.$cookies.get('CountryCode') != 'cn')) {
      // console.log(123, !hostS.includes('zh-cn'), (app.$cookies.get('CountryCode') != 'cn'))
      // store.commit('setMyCountry', { myCountry, hostS: host }) // 存储用户所在的国家
      // store.commit('setLangCode', { lang: 'zh-cn', hostS: host }) // 获取 语言
      // store.commit('setCountryCode', { country: 'cn', hostS: host }) // 获取国家
      country = 'cn'
      app.i18n.locale = 'zh-cn'
      if (!hostS.includes('/zh-cn')) return redirect(302, `/zh-cn/${route.fullPath.split('/').slice(2).join('/')}`)
    }
  }
  if (routeLang == 'zh-tw' || routeLang == 'zh-hk') return redirect(301, `/zh/${route.fullPath.split('/').slice(2).join('/')}`) // 台湾或者香港跳转到zh
  if (route.fullPath == `/${routeLang}/survey`) return redirect(301, `/${routeLang}/survey/all/1.html`)
  if (!routeLang || !store.state.langList.includes(routeLang)) {
    // 用户没有通过语言直接通过域名访问
    return await getCookieLanguageCode(req, app, redirect, store, route) // 设置语言cookie
  }
  store.commit('setMobile', iPhone(req)) // 判断是否移动端
  // console.log(req?.headers['accept-language']?.split(',')[0]?.toLowerCase(), 12322)
  // 不带.html后缀的各类详情页url,补齐.html
  if (!route.path.includes('.html')) {
    const allDetail = '/dealer/,/newsdetail/,/exposure/,/market/,/survey/,/intro/,/class/,/brokers/,/wikishow/'
    const curDetail = route.path.toLowerCase().split('/')
    if (curDetail.length >= 4 && allDetail.includes(curDetail[2])) {
      return redirect(302, `${process.env.NODE_ENV != 'production' && (host.includes('192.168.') || host.includes('localhost')) ? 'http' : 'https'}://${host}${route.fullPath}.html`)
    }
  }
  country = country.toLowerCase() == 'gb' ? 'uk' : country
  let countryArr = []
  if (routeLang == 'zh-cn' || routeLang == 'zh-tw' || routeLang == 'zh-hk' || routeLang == 'zh') {
    // countryArr = require('~/static/json/areaCodeCN.json')
    countryArr = await $api.home.areaCodeCN().catch(() => {
      console.log('areaCodeCN')
    })
  } else {
    // countryArr = require('~/static/json/areaCodeEn.json')
    countryArr = await $api.home.areaCodeEn().catch(() => {
      console.log('areaCodeEn')
    })
  }

  let countryInfo = {}
  countryArr &&
    countryArr.forEach((item) => {
      item.data.forEach((itemS) => {
        if (country.toLowerCase() == itemS.twoCharCode.toLowerCase()) {
          countryInfo = itemS
        }
      })
    })
  // 用户登录
  const DJkdikKMG = app.$cookies.get('DJkdikKMG')
  const ViLartidlakd = app.$cookies.get('ViLartidlakd')
  const WsdsfgDGdagYms = app.$cookies.get('WsdsfgDGdagYms')
  const VEST = app.$cookies.get('VEST')
  // const ck = 'xi%2fp8hiegNuZv73%2ftBI%2fZg%3d%3d%7c99520%7chttps%3a%2f%2fimg.fx696.com%2favatar%2f1405065881%2f1405065881_28073.bmp_wiki-template-global%7c9652667659%7c0faccb616a6130f262fed6a014b5ca3e'
  // || ck
  const contentcookie = DJkdikKMG || ViLartidlakd || WsdsfgDGdagYms || VEST
  // console.log('contentcookie: ', contentcookie)
  let login = null
  if (contentcookie) {
    login = $api.home
      .getUsercookie({
        contentcookie
      })
      .catch(() => {
        console.log('login')
      })
  }
  store.commit('setLangCode', { lang: routeLang, hostS: host }) // 获取语言
  store.commit('setCountryCode', { country, hostS: host }) // 获取国家
  store.commit('setMyCountry', { myCountry, hostS: host }) // 存储用户所在的国家
  store.commit('setInfo', countryInfo) // 获取国家code，国家名称，国家代码，国旗
  store.commit('setuserCountry', countryInfo) // 用户中心获取国家code，国家名称，国家代码，国旗
  // if (country == 'hk') { // 香港地区所有广告位不显示
  //   const tp = new Date('2023-03-31').getTime() - new Date().getTime()
  //   if (tp > 0) store.commit('setadallshow', false)
  // }
  // const isWikifx = (store.state.isWiki == '1') // !不是这2个域名=>true
  // const isSH = store.state?.curCity?.indexOf('上海') > -1 // !是上海 => true
  // if (country == 'cn' && isSH && !isWikifx) { // 在上海地区并且不是wikifx域名下进行的屏蔽逻辑
  //   store.commit('setshshow', false)
  // }
  // 头部菜单-1
  const headermenu = $api.list.headermenu().catch(() => {
    console.log('headermenu')
  })
  // 底部联系方式-1
  const contactinfo = $api.list.contactinfo().catch(() => {
    console.log('contactinfo')
  })

  // 底部国家-1
  const footcountry = $api.home.country().catch(() => {
    console.log('footcountry')
  })

  // 友情链接-1
  const linksList = $api.home.getFriendlinks().catch(() => {
    console.log('getFriendlinks---error')
  })

  // 战略合作-1
  const partnerList = $api.home.getPartnetlist().catch(() => {
    console.log('partnerList----ERROR')
  })

  // 直播状态
  const liveroom = $api.home.liveroom({ liveCountStatus: '1' }).catch(() => {
    console.log('liveroom')
  })
  // if (store.state.isWiki == '2' || store.state.isWiki == '3' || store.state.isWiki == '4') { // 屏蔽 中心-1
  //   pingBi = $api.home.getmanybyproj().catch(() => {
  //     console.log('partnerList')
  //   })
  // }
  // 推荐交易商,wikibit$evaluationgetbottomtab
  // ,wikistockweb$brokerwikifx -- 根据大佬要求9.27隐藏
  // console.log(route?.fullPath)
  const noncoop = $api.home
    .invokev3data(
      {
        route: route?.fullPath
      },
      {
        Routes: 'wikifx$noncooperativetraderv2'
      },
      noncooperativetrader
    )
    .catch(() => {
      console.log('推荐交易商')
    })

  // 屏蔽点位
  const risk = $api.home.riskcontrol({}).catch(() => {
    console.log('riskcontrol')
  })

  // lcs
  const userid = app.$cookies.get('userid') || ''
  const lcs = $api.home
    .invokev3data(
      {
        // 推荐交易商,wikibit$evaluationgetbottomtab
        userid
      },
      {
        Routes: 'lcs$userslcsenterprise'
      }
    )
    .catch(() => {
      console.log('lcs')
    })
  const getAvatarFrame = $api.common
    .V3(
      {
        userid: app.$cookies.get('userid') || ''
      },
      {
        Routes: 'usercenter$getuserframe'
      }
    )
    .catch(() => {
      console.log('usercenter$getuserframe')
    })
  // console.log(route?.fullPath?.includes('source=app'), 888)
  // if (route?.fullPath?.includes('source=app')) { // app内嵌的情况下设置国家
  //   store.commit('setCountryCode', { country: route?.query?.country || country, hostS: host }) // 获取国家
  // }
  return Promise.all([login, headermenu, contactinfo, footcountry, linksList, partnerList, noncoop, liveroom, risk, lcs, getAvatarFrame]).then((result) => {
    // console.log(result[6])
    const menuArr = []
    if (result[1]) {
      // 菜单处理
      result[1].forEach((item) => {
        const t = menu.filter((items) => items.code == item.code)
        if (t[0]) menuArr.push(t[0])
      })
    }
    const user = result[0] && result[0].result && result[0].result.userId ? result[0].result : {}
    const avatarFrame = result && result[10]?.usercenter?.getuserframe?.data
    const ISVEST = DJkdikKMG || ViLartidlakd || WsdsfgDGdagYms // 如果有cookie值也有马甲cookie值则vest为true
    if (VEST && ISVEST) user.vest = true
    else user.vest = false
    result[3] &&
      result[3].forEach((item) => {
        item.abbr = item.twoCharCode.toLowerCase()
        if (routeLang == 'ru' && item.code == '840') item.name = 'США'
      })
    const ccloc = route.query && route.query.cc_loc
    // console.log(result[3], 1111)
    result[3] &&
      result[3].forEach((item) => {
        if (item.code == '344') {
          // item.name = item.name.replace('、中国', '').replace('中国', '').replace('中國', '').replace('China', '')
          item.code = '156'
          item.url = ''
          item.twoCharCode = 'CN'
          item.abbr = 'cn'
        }
        // if (item.code == '158') item.name = item.name.replace('、中国', '').replace('中国', '').replace('中國', '').replace('China', '')
        if (route.name == 'lang-dealer-id' && hostS.includes('cc_loc') && ccloc && item.abbr == ccloc.toLowerCase()) {
          store.commit('setCountryCode', { country: 'hk', hostS: host }) // 获取国家
          store.commit('setInfo', {
            countryCode: '344',
            twoCharCode: 'HK',
            code: '00852',
            name: '香港',
            flag: 'https://img.souhei.com.cn/flag/ccc558d92f93bcf8/HK.png_wiki-template-global',
            'flag-c': 'https://img.souhei.com.cn/flag-c/ccc558d92f93bcf8.png_wiki-template-global'
          }) // 获取国家code，国家名称，国家代码，国旗
        }
      })
    // console.log(route, 1111, 'lang-dealer-id', hostS, result[3][0], countryInfo)
    const coop = result[6] && result[6].wikifx && result[6].wikifx.noncooperativetraderv2 && result[6].wikifx.noncooperativetraderv2.data ? result[6].wikifx.noncooperativetraderv2.data : []
    // const brokerwikifx = result[6]?.wikistockweb?.brokerwikifx?.data?.items || [] // -- 根据大佬要求9.27隐藏
    // console.log(brokerwikifx, 888)
    const lcs = (result[9] && result[9].lcs && result[9].lcs.userslcsenterprise && result[9].lcs.userslcsenterprise.data) || {}
    store.commit('setlcsdata', lcs)
    store.commit('setnonCooperativeTraders', coop) // fx推荐
    // const lg = ['zh-cn', 'zh', 'en', 'ja', 'th', 'vi', 'id', 'fil'] // 跟着stock语言走 // -- 根据大佬要求9.27隐藏
    // if (lg.includes(routeLang)) store.commit('setbrokerwikifx', brokerwikifx) // fx推荐

    // 是否是去中文点位配置
    const riskRet = result[8] ? result[8] : {}
    const riskArr = Object.keys(riskRet)
    let riskRemoveZhcn = false
    riskArr.forEach((rit) => {
      if (rit == '351001' && riskRet[rit] == '0') {
        riskRemoveZhcn = true
      }
    })

    // 去中文点位判断[语言跳转]
    if ((routeLang == 'zh-cn' || routeLang == 'zh') && riskRemoveZhcn) {
      redirect(302, `/en/${route.fullPath.split('/').slice(2).join('/')}`)
    }
    store.commit('setriskcontrol', result[8] ? result[8] : {}) // 屏蔽点位
    // console.log('setriskcontrol', result[8])
    store.commit('setPartnerList', result[5] ? result[5] : []) // 战略合作
    store.commit('setlinkFriend', result[4] ? result[4] : []) // 友情链接
    store.commit('setMenu', menuArr) // 获取菜单数据
    store.commit('setConfigure', index) // 首页配置
    store.commit('setContactinfo', result[2]) // 底部联系方式
    store.commit('setUser', user) // 获取用户登录cookie
    store.commit('setUserVip', !!user?.vipExpiredAt)
    store.commit('setUserAvatarFrame', avatarFrame || '') // 用户头像
    store.commit('setUsercookie', contentcookie) // 获取用户登录cookie
    const tuijianLan = req?.headers['accept-language']?.split(',')[0]?.toLowerCase()
    // 去中文点位判断[推荐语言,是否显示语言切换]
    // console.log('tuijianLan', tuijianLan)
    if (tuijianLan != routeLang && !app.$cookies.get('swlang')) {
      if (riskRemoveZhcn) {
        if (tuijianLan != 'zh-cn' && tuijianLan != 'zh') {
          store.commit('setlangsw', true)
        }
      } else {
        store.commit('setlangsw', true)
      }
    }
    if ((tuijianLan == 'zh-cn' || tuijianLan == 'zh') && tuijianLan != routeLang && !app.$cookies.get('swlang')) {
      const riskRet = result[8] ? result[8] : {}
      const riskArr = Object.keys(riskRet)
      let riskRemoveZhcn = false
      riskArr.forEach((rit) => {
        if (rit == '351001' && riskRet[rit] == '0') {
          riskRemoveZhcn = true
        }
      })

      // console.log('riskRemoveZhcn----222', riskRemoveZhcn)
      if (riskRemoveZhcn) {
        store.commit('setlangsw', true)
      }
    } else if (tuijianLan != routeLang && !app.$cookies.get('swlang')) {
      store.commit('setlangsw', true)
    }
    // store.commit('setuserCountry', userCountryInfo) // 用户中心获取国家code，国家名称，国家代码，国旗
    store.commit('setfootCountry', result[3] ? result[3] : []) // 设置底部国家
    store.commit('setLivestate', result[7] ? result[7] : {}) // 获取直播状态
    app.i18n.locale = routeLang
  })
}
